"use strict";

var debug = require("debug")("knack.formatter.formatters.profile");

/**
 * @alias "formatters.profile"
 * @param {String[]} value
 * @param {Object} fieldFormat
 * @param {String} responseFormat
 * @param {Object} options
 * @return {String}
 */
var profileFormatter = function profileFormatter(value, fieldFormat, responseFormat, options) {
  responseFormat = responseFormat || "html";
  var profiles = "";
  if (!value) {
    return "";
  }
  value.forEach(function (profileKey) {
    if (profileKey) {
      var profile = options.application.getUserObject(profileKey);
      if (profile && profile.name) {
        if (responseFormat === "html") {
          if (profiles !== "") {
            profiles += "<br />";
          }
          profiles += "<span class=\"".concat(profileKey, "\">").concat(profile.name, "</span>");
        } else {
          profiles += "".concat(profile.name, "\n");
        }
      }
    }
  });
  if (responseFormat === "html") {

    // profiles += '</ul>';
  } else {
    profiles = profiles.substr(0, profiles.length - 1);
  }
  return profiles;
};
module.exports = profileFormatter;